var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-wrap',{staticClass:"wxsm"},[_c('el-card',{staticClass:"box-card",staticStyle:{"width":"100%"},attrs:{"shadow":"never"}},[_c('h2',{staticClass:"xpqd"},[_vm._v("微信绑定")]),_vm._v(" "),_c('p',[_vm._v("用微信扫描下方二维码，进行绑定操作，即可第一时间收到微信服务通知，询盘信息实时送达！")]),_vm._v(" "),_c('img',{staticStyle:{"height":"200px","width":"200px","margin":"20px 100px"},attrs:{"src":_vm.wechat}})])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3473c20","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/business/Wechat.vue
// module id = null
// module chunks = 